import React, { useRef, useCallback } from 'react';
import  { useState } from 'react';
import  { useEffect }from 'react';
import  { 
    useMemo,
  
    StrictMode, } from 'react';
import { useLocation } from 'react-router-dom';
import './ZuteStranice.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import { DataGrid } from '@mui/x-data-grid';

import { APICall } from './services/api.service';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from "./redux/actions"

import { useNavigate } from "react-router-dom";

import Fab from '@mui/material/Fab';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2'



import { AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";



import {
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ModuleRegistry,
    ValidationModule,
    createGrid,
    themeQuartz,
    themeBalham,

    RowSelectionModule,
    RowApiModule


} from "ag-grid-community";


  
  
ModuleRegistry.registerModules([
    RowSelectionModule,
    ClientSideRowModelModule,


    ValidationModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    RowApiModule
    
]);
  
  
  
const myTheme = themeBalham.withParams({
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    //selectedRowBackgroundColor: 'rgba(0, 255, 0, 0.1)',
    selectedRowBackgroundColor: '#8386a6',
    fontWeight:400
});
    
  


const theme = createTheme({
    palette: {
        primary: {
            main: '#520074',
            lightyellow: '#FFFDD0' 
        }
    },
});




function ZuteStranice(props) {



    /******************************************************************************************************************************** */
    /******************************************************************************************************************************** */
    /******************************************************************************************************************************** */
    
    /**************************************************TVRTKE GRID******************************************************************* */
    /******************************************************************************************************************************** */
    /******************************************************************************************************************************** */
    /******************************************************************************************************************************** */
    
    const gridRef_Tvrtke = useRef();
    
    const themeAG = useMemo(() => {
        return myTheme;
    }, []);
    
    const autoSizeStrategy_Tvrtke  = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : true
        };
      }, []);
    
      const autoSizeAll_Tvrtke  = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef_Tvrtke .current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef_Tvrtke .current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);
    
    
      const onGridReady_Tvrtke  = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll_Tvrtke ();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);
    
    
    
      const onColumnResized_Tvrtke  = useCallback((params) => {
        //console.log(params);
      }, []);
    
    
    
     const cellClicked_Tvrtke  = useCallback((cell)=>{
    
    
                let row = cell.data;

                console.log("Selected: ");

                setSifra(row.sifra);
                

                console.log("Sifra; ");
                console.log(row.sifra);

                

                setCompanyTKC(row.tkc);

                const selected = listOfPozivni.find((obj) => {
                    console.log("Checking");
                    console.log(obj);
                    console.log(obj.pozivni);
                    console.log(row.tkc);
                    
                    if (obj.tkc === row.tkc)
                    return obj;
                });
                console.log(selected);

                setSelectedNetwork(selected);
    
          
                sessionStorage.setItem("selectedNet", JSON.stringify(selected));


                setShowCompanies(false);

                getCompanySifra(row.sifra, row.tkc);





     })
    


    /******************************************************************************************************************************** */
    /******************************************************************************************************************************** */
    /******************************************************************************************************************************** */
    
    /**************************************************STATE VARS******************************************************************** */
    /******************************************************************************************************************************** */
    /******************************************************************************************************************************** */
    /******************************************************************************************************************************** */


     const [tableData, setTableData] = useState([]);
     const [tableDataModal, setTableDataModal] = useState([]);
     const [openModal, setOpenModal] = useState(true);
     const handleOpen = () => setOpenModal(true);
     const handleClose = () => setOpenModal(false);
 
     const dispatch = useDispatch()
 
 
     const navigate = useNavigate();
 
     const [curr_time, setCurrTime] = useState('');
 
     const token = localStorage.getItem("token");
 
     //const { user: currentUser } = useSelector((state) => state.auth);
     const user = localStorage.getItem("user");
     const username = localStorage.getItem("username");
     const ref = localStorage.getItem("id");
 
     const [sifra, setSifra] = useState("");
 
 
     /********************************************************************************************** */
 
 
     //const tkc = JSON.parse(localStorage.getItem("tkc"));
 
     const [listOfPozivni, setListOfPozivni] = useState([]);
 
     const [selectedNetwork, setSelectedNetwork] = useState(null);
 
     const [disableSelNet, setDisableSelNet] = useState(false);
 
     /********************************************************************************************** */
 
     const [naziv, setNaziv] = useState("");
     const [naziv2, setNaziv2] = useState("");
     const [mjesto, setMjesto] = useState("");
     const [ulica, setUlica] = useState("");
     const [kbr, setKbr] = useState("");
     const [komentar, setKomentar] = useState("");
     const [komentar2, setKomentar2] = useState("");
     const [slova, setSlova] = useState("");

     const [ulicaID, setUlicaID] = useState(0);
     const [mjestoID, setMjestoID] = useState(0);

     const [companyTKC, setCompanyTKC] = useState('');


     const [addNazivContainerIsVisible,setAddNazivContainerIsVisible] = useState("")
     const [searchNaziv, setSearchNaziv] = useState("");
     const [filteredTableData, setFilteredTableData] = useState([])
     const [allDjelatnosti, setAllDjelatnosti] = useState([])
     
 
 
     //const { state } = props;
     //const { row } = state;
     const location = useLocation();
     const { row } = location.state?location.state:'';
 
     
 
     const [addNew, setAddNew] = useState(false);
 
     const [companyAdded, setCompanyAdded] = useState(false);
 
     const [showCompanies, setShowCompanies] = useState(false);
     const [foundCompanies, setFoundCompanies] = useState([]);
     const [isDragging, setIsDragging] = useState(false)
     const [modalPosition, setModalPosition] = useState({x:0,y:0})
     const startPosition = useRef({x:0,y:0})
     const popupRef = useRef(null)
     const [modalIsOpen, setModalIsOpen] = useState(false)
     const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)
    
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*********************************MODAL RESIZE/MOVE****************************************************************************** */
/******************************************************************************************************************************** */

const [isDraggingTvrtke, setIsDraggingTvrtke] = useState(false)
const [tvrtkePosition,setTvrtkePosition] = useState(false)

const [modalTvrtkePosition, setModalTvrtkePosition] = useState({x:0,y:0})
const startPositionTvrtke = useRef({x:0,y:0})
const popupRefTvrtke = useRef(null)


const resetPositionModal=(e)=>{




    if(e.keyCode==81 ) {
        console.log("Testing");



        if(setShowCompanies){
            setModalTvrtkePosition({x:0,y:0});

        }else{
            console.log("Ignore!!!");
        }
    }
}








const onMouseMove = useCallback((e) => {

  if (!isDraggingTvrtke) return;
    setModalTvrtkePosition({
        x: e.clientX - startPositionTvrtke.current.x,
        y: e.clientY - startPositionTvrtke.current.y,
    });

  if (!isDragging) return;
  setModalPosition({
    x: e.clientX - startPosition.current.x,
    y: e.clientY - startPosition.current.y,
  });
  
},
[isDragging, isDraggingTvrtke]
);

// Function to handle the end of a drag event
const onMouseUp = () => {

    setIsDraggingTvrtke(false);
    setIsDragging(false);
};

const onMouseDown = (e) => {
console.log("on mouse down")
e.stopPropagation();

console.log("Modal is open?");
console.log(openModal)


setIsDraggingTvrtke(true);
startPositionTvrtke.current = { x: e.clientX - modalTvrtkePosition.x, y: e.clientY - modalTvrtkePosition.y }
setIsDragging(true);
startPosition.current = { x: e.clientX - modalPosition.x, y: e.clientY - modalPosition.y }



}


useEffect(() => {
window.addEventListener("mousemove", onMouseMove);
window.addEventListener("mouseup", onMouseUp);
window.addEventListener("keydown", resetPositionModal);

return () => {
  window.removeEventListener("mousemove", onMouseMove);
  window.removeEventListener("mouseup", onMouseUp);
  window.removeEventListener("keydown", resetPositionModal);

};
}, [onMouseMove], resetPositionModal);

// Reset position when the popup is closed
useEffect(() => {

if (!foundCompanies) {
    setTvrtkePosition({ x: 0, y: 0 });
}
if (!modalIsOpen) {
    setModalPosition({ x: 0, y: 0 });
  }
}, [modalIsOpen, foundCompanies]);


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
   


   const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };





    useEffect(() => {



        GetPozivni();

        console.log("Getting the selected Ntwork")
    
  
        const storedData = sessionStorage.getItem("selectedNet");

        console.log(storedData)
        if (storedData) {
    
            console.log("Found stored data somehow?")
            try {
                const parsedData = JSON.parse(storedData);
                setSelectedNetwork(parsedData);
                console.log(parsedData);
                } catch (error) {
                console.error("Error parsing sessionStorage:", error);
                sessionStorage.removeItem("selectedNet"); 
                }
    
        }

        console.log("Dolazne info?");

        //console.log(row);
        console.log("props", props)

        setModalIsOpen(props.zuteStraniceIsOpen)

        //if(row && row!=''){
        if(props.state && props.state.row && props.state.row!=''){

                    let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';

                    console.log("Tkc in zute");
                    console.log(tmpTKC)
            
                    //let tel = row.Telefon;
            
                    let tel = props.state.row.Telefon;

                    console.log(tel);
            
                
                    let tmpTel = '';
                    let tmpMreza = '';
                
                    if(tel.startsWith('01')){
                
                        tmpTel = tel.slice(2);
                        tmpMreza = tel.slice(1,2);
                
                    }else {
                        tmpTel = tel.slice(3);
                        tmpMreza = tel.slice(1,3);
                
                    }
            
            
                    console.log(tmpTel);
                    console.log("MREZA");
                    console.log(tmpMreza);
            
                    //console.log(row.TKC);
                    console.log(props.state.row.TKC);

                    //if(tmpTel && tmpTel != '' && tmpMreza && tmpMreza!='' && row.TKC && row.TKC!=''){
                    if(tmpTel && tmpTel != '' && tmpMreza && tmpMreza!='' && props.state.row.TKC && props.state.row.TKC!=''){

                        console.log("Getting the data from phone:");

                        getCompanyFromPhone(tmpTel, tmpMreza, props.state.row.TKC);
                    
                    }                    

        }




        let tmp = new Date();
    
        console.log(tmp);
    
        tmp.setMinutes(tmp.getMinutes() - 25);
    
        console.log(tmp);

        console.log("Getting data");
        console.log(row)
    
        let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + " " + tmp.getHours() + ":" + tmp.getMinutes();
    
        console.log(timeNow);
    
        
        setCurrTime(timeNow);


    
    
    
    }, []);


useEffect(()=>{
        document.title="Žute stranice"
},[])




/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************FUNKCIJE*********************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const GetPozivni = async() => {
    dispatch(actions.isLoading());
    await  APICall("/GetPozivni", {
      platform: '0',
      version:'1.0'
    },{
      token
    }).then(response =>{
            if(response.status !== 200) {

              if(response.status == 401){

                      console.log("Istekla sesija");

                      toast.error(response.data.message, toastError);
                      
                      dispatch(actions.logOut());
                      navigate('/');

              } else{

                      //toast.error(response.data.message, toastError);

              }


          } else {
              

                  let tmp = response.data.list;
                  tmp = tmp.sort((a,b) => a.pozivni - b.pozivni);

                  console.log("aaaaaaaaaaa list of pozivni seeeeeeeeeeet")

                  setListOfPozivni(tmp);
          }


          if (response==undefined) dispatch(actions.isNotLoading());
    })
    dispatch(actions.isNotLoading());
};

const handleChange = (event) => {

    console.log(event.target);

    let sel = '';

    if(event.target.value && event.target.value!=''){
            const selected = listOfPozivni.find((obj) => {
                console.log("Checking");
                console.log(obj);
                console.log(obj.pozivni);
                console.log(event.target.value);
                
                if (obj.pozivni === event.target.value)
                return obj;
            });
            console.log(selected);
            setSelectedNetwork(selected);

            sel = selected;
            sessionStorage.setItem("selectedNet", JSON.stringify(selected));

    } else {

            sel = {pozivni:'', tkc:''}
            console.log("Setting");
            console.log(sel);
            setSelectedNetwork(sel);
            sessionStorage.setItem("selectedNet", JSON.stringify(sel));

    }

    console.log("Did the network change!!!");


};


async function getCompany() {

    


    console.log("Getting company");



    let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';

    

    console.log(sifra);
    console.log(tmpTKC);

    console.log(token)



    if((!sifra || sifra=="") && (!naziv || naziv=='')){

            toast.warning("Morate unijeti ispravnu šifru tvrtke ili naziv", toastInfo)

    } else {

            dispatch(actions.isLoading());

            APICall("/GetCompanyZute", {

                platform: '0',
                version:'1.0',
                tkc: tmpTKC,
                sifra: sifra,
                naziv: naziv

            }, {
                token
            }).then(response=>{
                
                console.log(response)

                dispatch(actions.isNotLoading());

                if(response.status !== 200) {

                    

                    if(response.status == 401){

                        console.log("Istekla sesija");

                        toast.error(response.data.message, toastError);

                        setCompanyAdded(false);
                        
                        dispatch(actions.logOut());
                        navigate('/');

                        

                    } else{

                            toast.error(response.data.message, toastError);

                            setCompanyAdded(false);

                            

                    }


                } else {
                    
                    console.log(response.data);

                    console.log(response.data.list)

                    

                    if(response.data.list && response.data.list.length==1){

                            

                            console.log("Woohooo");
                            console.log(response.data.list[0]);
                            console.log("blabalbala");

                            if(response.data.list[0].naziv){
                            setNaziv(response.data.list[0].naziv);
                            setNaziv2(response.data.list[0].naziv);
                            }
                            //console.log(response.data.list[0].fd_naziv)

                            if(response.data.list[0].komentar)
                                setKomentar(response.data.list[0].komentar);
                            if(response.data.list[0].komentar2)
                                setKomentar2(response.data.list[0].komentar2);
                            if(response.data.list[0].kbr)
                                setKbr(response.data.list[0].kbr);
                            if(response.data.list[0].sifra)
                                setSifra(response.data.list[0].sifra);
                            if(response.data.list[0].alfa)
                                setSlova(response.data.list[0].alfa);
                            if(response.data.list[0].ulica_naziv)
                                setUlica(response.data.list[0].ulica_naziv);
                            if(response.data.list[0].sifra_ulice)
                                setUlicaID(response.data.list[0].sifra_ulice);
                            if(response.data.list[0].mjesto_naziv)
                                setMjesto(response.data.list[0].mjesto_naziv);                            
                            if(response.data.list[0].MJESTO_ID)
                                setMjestoID(response.data.list[0].MJESTO_ID);



                            if(response.data.list[0].tkc){

                                    setCompanyTKC(response.data.list[0].tkc?response.data.list[0].tkc:'');

                                    const selected = listOfPozivni.find((obj) => {
                                        console.log("Checking");
                                        console.log(obj);
                                        console.log(obj.pozivni);
                                        console.log(response.data.list[0].tkc);
                                        
                                        if (obj.tkc === response.data.list[0].tkc)
                                        return obj;
                                    });
                                    console.log(selected);
                    
                                    setSelectedNetwork(selected);
                        
                            
                                    sessionStorage.setItem("selectedNet", JSON.stringify(selected));

                            }

                            console.log(response.data.type);

                            if(response.data.type!=1){

                                    setTableDataModal(response.data.list2);

                            }

                            setCompanyAdded(true);


                    } else if (response.data.list && response.data.list.length!=1 && response.data.length !=0){

                        console.log("Ima više firmi!!!");
                        console.log(response.data.list);

                        let columns= Object.getOwnPropertyNames(response.data.list[0]).map((column,index)=>{
                            var a = column.charAt(0).toUpperCase() + column.slice(1)
                                return(
                                    {
                                        "field": column,
                                        "getRowId": index
                                    }
                                )
                            })
                            let rows = response.data.list.map((item, index)=> {
                                return({...item,id:index})
                            })

                            setFoundCompanies({
                                    columns,
                                    rows
                            })

            


                        setShowCompanies(true);
                        

                    
                    } else {

                        toast.error("Nije pronađena tražena tvrtka, molimo provjerite unos", toastError);

                        setCompanyAdded(false);
                    }


                }
                
            
            }).catch(error=> {
                    
                    dispatch(actions.isNotLoading());
                    console.log(error);


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                    setCompanyAdded(false);

                
            })

    }
        
}



async function getCompanySifra(sifra, tmpTKC) {


    console.log("Getting company");


    console.log(sifra);
    console.log(tmpTKC);


    if(!sifra || sifra==""){

            toast.warning("Morate unijeti ispravnu šifru tvrtke", toastInfo)

    } else {


        dispatch(actions.isLoading());


        APICall("/GetCompanyZute", {

            platform: '0',
            version:'1.0',
            tkc: tmpTKC,
            sifra: sifra,
            naziv: ""

        }, {
            token
        }).then(response=>{
            
            console.log(response)

            dispatch(actions.isNotLoading());


            if(response.status !== 200) {

                if(response.status == 401){

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);

                    setCompanyAdded(false);
                    
                    dispatch(actions.logOut());
                    navigate('/');

                    

                } else{

                        toast.error(response.data.message, toastError);

                        setCompanyAdded(false);

                        

                }


            } else {
                
                console.log(response.data);

                console.log(response.data.list)

                

                if(response.data.list && response.data.list.length!=0){


                        if(response.data.list[0].naziv){
                            setNaziv(response.data.list[0].naziv);
                            setNaziv2(response.data.list[0].naziv);
                        }
                        //console.log(response.data.list[0].fd_naziv)

                        if(response.data.list[0].komentar)
                            setKomentar(response.data.list[0].komentar);
                        if(response.data.list[0].komentar2)
                            setKomentar2(response.data.list[0].komentar2);
                        if(response.data.list[0].kbr)
                            setKbr(response.data.list[0].kbr);
                        if(response.data.list[0].sifra)
                            setSifra(response.data.list[0].sifra);
                        if(response.data.list[0].alfa)
                            setSlova(response.data.list[0].alfa);


                        if(response.data.list[0].ulica_naziv)
                            setUlica(response.data.list[0].ulica_naziv);
                        if(response.data.list[0].sifra_ulice)
                            setUlicaID(response.data.list[0].sifra_ulice);
                        if(response.data.list[0].mjesto_naziv)
                            setMjesto(response.data.list[0].mjesto_naziv);                            
                        if(response.data.list[0].MJESTO_ID)
                            setMjestoID(response.data.list[0].MJESTO_ID);

                        if(response.data.list[0].tkc){

                            setCompanyTKC(response.data.list[0].tkc?response.data.list[0].tkc:'');

                            const selected = listOfPozivni.find((obj) => {
                                console.log("Checking");
                                console.log(obj);
                                console.log(obj.pozivni);
                                console.log(response.data.list[0].tkc);
                                
                                if (obj.tkc === response.data.list[0].tkc)
                                return obj;
                            });
                            console.log(selected);
            
                            setSelectedNetwork(selected);
                
                    
                            sessionStorage.setItem("selectedNet", JSON.stringify(selected));

                        }

                        console.log(response.data.type);

                        if(response.data.type!=1){

                                setTableDataModal(response.data.list2);

                        }

                        setCompanyAdded(true);


                } else {

                        toast.error("Nije pronađena tražena tvrtka, molimo provjerite unos", toastError);

                        setCompanyAdded(false);
                }


            }
            
        
        }).catch(error=> {
                
                dispatch(actions.isNotLoading());

                console.log(error);


                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                    toastError);                    

                setCompanyAdded(false);

            
        })

}
        
}



const getDjelatnosti = () => {

    dispatch(actions.isLoading());


    APICall("/getDjelatnosti", {

        platform: '0',
        version:'1.0',

        searchNaziv

    }, {
        token
    }).then(response=>{
        
        console.log(response)

        dispatch(actions.isNotLoading());

        if(response.status !== 200) {

            if(response.status == 401){

                console.log("Istekla sesija");

                toast.error(response.data.message, toastError);
                
                dispatch(actions.logOut());
                navigate('/');

            } else{

                    toast.error(response.data.message, toastError);

                    

            }


        } else {
            
            if(response.data.list && response.data.list.length!=0){
                var dataTmp = response.data;
                setAllDjelatnosti(dataTmp)



                let i = 0;


                let columns = [{
                    "field": "naziv",
                    "getRowId": 1, minWidth: 250
                }]
                let rows =dataTmp.list.map((item, index)=> {
                        console.log(item.naziv)
                    return({naziv:item.naziv, 
                        id:index})
                })
                console.log({
                    columns,
                    rows
                })

                setFilteredTableData({
                        columns,
                        rows
                })



                    
            }else{



                        //toast.info(response.data.message,
                        //    toastInfo);
                    
                        //setTableData([]);


                    

            }




        }
        
    
    }).catch(error=> {
            
            console.log(error);

            dispatch(actions.isNotLoading());


            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                toastError);                    

        
    })
}



const addDjelatnost = (data) => {

    //let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';
    let tmpTKC = companyTKC;

    console.log("Adding djelatnost");


    console.log(tmpTKC);

    if(!tmpTKC || tmpTKC=='' || !sifra || sifra=="" || !naziv || naziv=='' || !companyAdded){

            toast.warning("Nije ispravno unešeni svi podaci potrebni za unos", toastInfo)

    } else {

            dispatch(actions.isLoading());

            APICall("/addDjelatnost", {

                platform: '0',
                version:'1.0',
                tkc: tmpTKC,
                naziv: naziv,
                sifra: sifra,
                ulica: ulicaID,
                kbr: kbr,
                alfa: slova,
                data: data

            }, {
                token
            }).then(response=>{
                dispatch(actions.isNotLoading());

                console.log(response)


                setSearchNaziv('');

                setFilteredTableData([],[]);


                if(response.status !== 200) {

                                if(response.status == 401){

                                    console.log("Istekla sesija");

                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');

                                } else{
                                
                                    toast.error(response.data.message, toastError);

                                    

                                }


                } else {
                    console.log("Success");
                    console.log(response.data);

                    toast.success(response.data.message, toastSuccess);


                    getCompanySifra(sifra, companyTKC);





                }
                
            
            }).catch(error=> {
                    
                    setSearchNaziv('');

                    setFilteredTableData([],[]);

                    console.log(error);

                    dispatch(actions.isNotLoading());


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                
            })

    }
} 



const deleteDjelatnostZute = (sifra_djel) => {

    //let tmpTKC = selectedNetwork?selectedNetwork.tkc:'';
    let tmpTKC = companyTKC;

    console.log("Deleting djelatnost");

    console.log(sifra_djel);


    console.log(tmpTKC);

    if(!tmpTKC || tmpTKC=="" || !sifra || sifra=="" || !sifra_djel || sifra_djel=='' || !companyAdded){

            toast.warning("Nije ispravno unešeni svi podaci potrebni za brisanje tvrtke", toastInfo)

    } else {

            dispatch(actions.isLoading());

            APICall("/deleteDjelatnostZute", {

                platform: '0',
                version:'1.0',
                tkc: tmpTKC,

                sifra: sifra,
                sifra_djel: sifra_djel,

            }, {
                token
            }).then(response=>{
                
                console.log(response)

                dispatch(actions.isNotLoading());
                
                if(response.status !== 200) {

                                if(response.status == 401){

                                    console.log("Istekla sesija");

                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');

                                } else{
                                
                                    toast.error(response.data.message, toastError);

                                    

                                }


                } else {
                    console.log("Success");
                    console.log(response.data);

                    toast.success(response.data.message, toastSuccess);


                    getCompanySifra(sifra, companyTKC);


                }
                
            
            }).catch(error=> {
                    
                    console.log(error);

                    dispatch(actions.isNotLoading());


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                
            })

    }
} 








async function getCompanyFromPhone(tel, mreza, tkcCode) {



    console.log(tel);
    console.log(mreza);

    console.log(tkcCode)


    APICall("/GetCompanyFromBijele_Phone", {

        platform: '0',
        version:'1.0',
        tkc: tkcCode,
        tel: tel,
        mreza: mreza

    }, {
        token
    }).then(response=>{
        
        console.log(response)
        if(response.status !== 200) {

            if(response.status == 401){

                console.log("Istekla sesija");

                toast.error(response.data.message, toastError);
                
                dispatch(actions.logOut());
                navigate('/');

        } else{

                toast.error(response.data.message, toastError);

                

        }


        } else {
            
            console.log(response)

            console.log(response.data.list);
            console.log(response.data.list2);

            
            

            if(response.data.list){

                let compData = response.data.list;



                    console.log("Woohooo");
                    console.log(compData);
                    console.log("blabalbala");

                    if(compData.naziv){
                    setNaziv(compData.naziv);
                    setNaziv2(compData.naziv);
                    }
    

                    if(compData.komentar)
                        setKomentar(compData.komentar);
                    if(compData.komentar2)
                        setKomentar2(compData.komentar2);
                    if(compData.kbr)
                        setKbr(compData.kbr);
                    if(compData.sifra)
                        setSifra(compData.sifra);
                    if(compData.alfa)
                        setSlova(compData.alfa);
                    if(compData.ulica_naziv)
                        setUlica(compData.ulica_naziv);
                    if(compData.sifra_ulice)
                        setUlicaID(compData.sifra_ulice);
                    if(compData.mjesto_naziv)
                        setMjesto(compData.mjesto_naziv);                            
                    if(compData.MJESTO_ID)
                        setMjestoID(compData.MJESTO_ID);



                    if(compData.tkc){

                            setCompanyTKC(compData.tkc?compData.tkc:'');

                            const selected = listOfPozivni.find((obj) => {
                                console.log("Checking");
                                console.log(obj);
                                console.log(obj.pozivni);
                                console.log(compData.tkc);
                                
                                if (obj.tkc === compData.tkc)
                                return obj;
                            });
                            console.log(selected);
            
                            setSelectedNetwork(selected);
                
                    
                            sessionStorage.setItem("selectedNet", JSON.stringify(selected));

                    }

                    console.log(response.data.type);

                    if(response.data.type!=1){

                            setTableDataModal(response.data.list2);

                    }

                    setCompanyAdded(true);

            } else {

                    toast.error("Nije pronađena tražena tvrtka, molimo provjerite unos", toastError)
            }
                


        }
        
    
    }).catch(error=> {
            
            console.log(error);


            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                toastError);                    

            
    })


        
}
    








  return (
    <Box theme={theme}  className={modalIsOpen ? "DPDonat-modal-container zute" : "" }      
    style={{ transform: `translate(${modalPosition.x}px, ${modalPosition.y}px)` }} //to move out popup
    >


        <Modal
                          open={showCompanies}
                          onClose={()=> {
                              setShowCompanies(false)
                              setFoundCompanies([],[]);
                              
                          }}
            >

                        <Box className="DPDonat-modal-container"  ref={popupRefTvrtke}      
                                style={{resize: "both", transform: `translate(${modalTvrtkePosition.x}px, ${modalTvrtkePosition.y}px)` }}> 

                                <Box className = "DPDonat-modal-header" onClick={(e) => e.stopPropagation()}      onMouseDown={(e)=> onMouseDown(e)}>
                    
                                        
                                        <Typography className="DPDonat-header-title-text" variant="h6">
                                        <Typography> Tvrtke</Typography>
                                        </Typography>  
                                    
                                    

                                </Box>

                                    

                                    <Box className="BijeleStranice-modal-content" sx={{width:"90%", marginTop:"10px"}}>

                                    <Box className="BijeleStranice-modal-data-display">

                                        {foundCompanies && foundCompanies.rows && <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                                    rowData={foundCompanies.rows}
                                                    columnDefs={foundCompanies.columns}

                                            

                                                
                                                    ref={gridRef_Tvrtke}
                                                    theme={themeAG}
                                                
                                                    autoSizeStrategy={autoSizeStrategy_Tvrtke}
                                                    onGridReady={onGridReady_Tvrtke}
                                                    onColumnResized={onColumnResized_Tvrtke}

                                                
                                    
                                                    onRowClicked={cellClicked_Tvrtke}


                                        /></div> } 

                                       
                                    </Box>    

                                       
                                       

                                    </Box>
                                    <div className='DPDonat-modal-bottom'
        
                                        onMouseDown={(e)=>onMouseDown(e)}>

                                    </div>
                                </Box>

        </Modal>


        <div className="BijeleStranice-main-container"  style={{resize: modalIsOpen ? "both" : "unset",width: modalIsOpen ? "97vw" : "100%", height: modalIsOpen ? "97vh" : ""}} 
            ref={popupRef}
            onClick={(e) => e.stopPropagation()}
            >

            <div className={`BijeleStranice-header ${isMenuOpen ? "is-extended": ""}`} 
                   
                   onMouseEnter={()=> dispatch(actions.openMenu())}
                   onMouseLeave={()=> dispatch(actions.closeMenu())}
                   onMouseDown={(e)=> onMouseDown(e)}

            >

                <div className="BijeleStranice-header-title">
                    <Typography  className="BijeleStranice-header-title-text" variant="h5">
                        Val - ŽUTE STRANICE
                    </Typography>
                </div>

            </div>

        {/*<div className="ZuteStranice-main-container"  style={{width: !modalIsOpen ? "px" : "px", resize: modalIsOpen ? "both" : "unset", height: modalIsOpen ? "500px" : "", transform:modalIsOpen?`translateY(0px)`:`translateY(-25px)`}} 
            ref={popupRef}
            onClick={(e) => e.stopPropagation()} // to prevent event delegation to the overlay
         >
            <div className={`ZuteStranice-header ${isMenuOpen ? "": ""}`}            
                onMouseDown={(e)=> onMouseDown(e)}
            >


                <div className="ZuteStranice-header-title">
                    <Typography  className="ZuteStranice-header-title-text" variant="h5">
                        Val - Žute stranice
                    </Typography>

                </div>

            </div>*/}



            <div className="ZuteStranice-body">
                <div className="ZuteStranice-form">
                    <div className="ZuteStranice-form-first-part">
                        <div className="ZuteStranice-form-first-part-left">

                            <Grid container xs={12} sx={{padding:"7px", gap:"5px", marginBottom:'5px'}}>
                                <Grid xs={12}>
                                        <FormControl 
                                                                        fullWidth
                                                                        //variant="standard" 
                                                                        sx={{ m: 1, width:'25%', margin:0, marginLeft: 10}}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        >
                                                                    <InputLabel sx={{fontSize: 12}}>Mreža</InputLabel>
                                                                    <Select 
                                                                        sx={{height:32}}
                                                                        disabled = {disableSelNet}
                                                                        value={selectedNetwork?.pozivni || ""} onChange={handleChange}>
                                                                    {listOfPozivni.map((obj) => (
                                                                        <MenuItem key={obj.tkc} value={obj.pozivni}>
                                                                        {obj.pozivni}
                                                                        </MenuItem>
                                                                    ))}
                                                                    <MenuItem value={''} name={''} >Svi</MenuItem>
                                                                    </Select>
                                        </FormControl>
                                </Grid>
                                <Grid xs={12}></Grid>
                            </Grid>
                            <Grid container xs={12} sx={{padding:"7px", gap:"5px", backgroundColor:'#AFE1AF', marginLeft:'1px', borderColor:'#AFE1AF', borderRadius:'5px'}}>
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={naziv=== "" ? "Naziv": ""}
                                        
                                      
                                        variant="outlined"

                                        value={naziv}
                                        
                                        onChange={(event) => {
                                            setNaziv(event.target.value);
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter'){
                                                console.log('Enter Pressed')
                                                console.log(naziv);
                                                getCompany();
                                            }
                                        }}
                                    />

                                </Grid>
                             
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        variant="outlined"
                                        label={sifra=== "" ? "Zadana sifra:": ""}
                                        
                                      

                                        value={sifra}
                                        
                                        
                                        onChange={(event) => {
                                                    console.log(event.target.value);
                                                    setSifra(event.target.value);

                                                    
                                            
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter'){
                                                console.log('Enter Pressed')
                                                console.log(sifra);
                                                getCompany();
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid  xs={12}>
                                     <Button sx={{height:"30px", fontSize:"10px"}} color="success"
                                    onClick={() => {
                                        console.log("Trazim"); 
                                        getCompany();
                                      }}
                                    variant="contained" style={{marginTop: 5}}>Traži</Button>

                                     <Button sx={{height:"30px", fontSize:"10px"}} color="error"
                                    onClick={() => {
                                        console.log("Brišem"); 
                                
                                  

                                            setNaziv('');
                                            setNaziv2('');
                                     
                                            setKomentar('');
                                            setKomentar2('');
                                            setKbr('');
                                            setSifra('');
                                            setSlova('');
                                            setUlica('');
                                            setMjesto('');

                                            setMjestoID(0);
                                            setUlicaID(0);
                    
                        
                        
                                            setTableDataModal([]);
        
                                            setFilteredTableData([]);
        
                                            setSearchNaziv('');
        
                                            setCompanyAdded(false);
        
                                            setAddNew(false);
        
                                            setCompanyTKC('');
        
                                            let sel = {pozivni:'', tkc:''}
        
                                            setSelectedNetwork(sel);
            
                  
                                            sessionStorage.setItem("selectedNet", JSON.stringify(sel));
                        
                                            
                                      }}
                                    variant="contained" style={{marginTop: 5, marginLeft: 5}}>Očisti podatke</Button>

                                </Grid>
                            </Grid>


                        </div> 
                        <div className="ZuteStranice-form-first-part-right">
                        <Grid container xs={12} sx={{padding:"7px", gap:"5px", backgroundColor:'orange', marginRight:'1px', borderColor:'orange', borderRadius:'5px'}}>
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={naziv2=== "" ? "Naziv:": ""}
                                        
                                      

                                        value={naziv2}

                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            setNaziv2(event.target.value)
                                        }}
                                    />

                                </Grid>
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={mjesto=== "" ? "Mjesto:": ""}
                                        
                                      

                                        value={mjesto}
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            setMjesto(event.target.value);
                                        }}
                                    />


                                </Grid>
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={ulica=== "" ? "Ulica:": ""}
                                        
                                      

                                        value={ulica}
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            setUlica(event.target.value)
                                        }}
                                    />

                                </Grid>
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={kbr=== "" ? "KBr:": ""}
                                        
                                      

                                        value={kbr}
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            setKbr(event.target.value)
                                        }}
                                    />


                                </Grid>
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={slova=== "" ? "Slova:": ""}
                                        
                                      

                                        value={slova}
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            setSlova(event.target.value)
                                        }}
                                    />

                                </Grid>
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={komentar=== "" ? "Komentar:": ""}
                                        
                                      

                                        value={komentar}
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            setKomentar(event.target.value)
                                        }}
                                    />


                                </Grid>
                                <Grid xs={12}>
                                     <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={komentar2=== "" ? "Komentar 2:": ""}
                                        
                                      

                                        value={komentar2}
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            setKomentar2(event.target.value);
                                        }}
                                    />


                                </Grid>
                            </Grid>
                        </div>                


                    </div>  
                    <div className="ZuteStranice-form-second-part">
                        <TableContainer  sx={{ maxHeight: 350 }} component={Paper}>
                            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                       
                                        
                                        <TableCell sx={{fontWeight:600}} align="right">Šifra</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Tel</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Naziv djelatnosti</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Naziv</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Ulica</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Kbr</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Alfa</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Obj.Nas/Stru</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Komentar</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                {tableDataModal.map((row) => (
                                    <TableRow
                                    key={row.fd_djel}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}

                                    onClick={()=>{

                                        console.log("Chosen row!!!!!");
                                        console.log(row.naziv_djelatnosti)
                                        console.log(row.fd_djel);

                                        Swal.fire({
                                            customClass: {
                                                container: 'my-swal'
                                              },
                                            title: "Želite li obrisati djelatnost tvrtke?",
                                            showDenyButton: true,
                                            showCancelButton: true,
                                            showConfirmButton:false,
                                            //confirmButtonText: "Uredi",
                                            denyButtonText: 'Obriši',
                                            cancelButtonText: 'Odustani'
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                                console.log("Going to edit!!!!!!");
                                                console.log(row.fd_djel);
                                                console.log(sifra);
                                                //deleteDjelatnost(sifra, row.fd_djel);

                                              
                                            } else if (result.isDenied) {
                                                    
                                                console.log("Denied!!!!");

                                                console.log("Trebam obrisati");

                                                console.log(row.fd_djel);

                                                deleteDjelatnostZute(row.fd_djel);
                                             
                                            }else if(result.isDismissed){
                                                console.log('Odusataoooooo')
                                            }
                                          });                                        
        
                                    }}
                                    >


                                        <TableCell component="th" scope="row">
                                            {row.fd_djel}
                                        </TableCell>
                                        <TableCell align="right">{row.tel}</TableCell>
                                        <TableCell align="right">{row.naziv_djelatnosti}</TableCell>
                                        <TableCell align="right">{row.fd_naziv}</TableCell>
                                        <TableCell align="right">{row.ulica_naziv}</TableCell>
                                        <TableCell align="right">{row.fd_kbr}</TableCell>
                                        <TableCell align="right">{row.fd_alfa}</TableCell>
                                        <TableCell align="right">{row.knjiga_count}</TableCell>
                                        <TableCell align="right">{row.fd_komentar}</TableCell>

                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                                       
                    </div>  
                    <div className='ZuteStranice-form-third-part'>
                        <div className='ZuteStranice-form-buttons'>

                             <Button sx={{height:"30px", fontSize:"10px"}} 
                                variant="contained" 

                                style={{marginTop: 5}}
                                disabled={!companyAdded}
                                onClick={() => {
                                        
                                        setAddNazivContainerIsVisible(true)

                                        setAddNew(true);
                                        
                                    }}
                                >
                                    
                                            Nova djelatnost
                            </Button>
                            {/* <Button sx={{height:"30px", fontSize:"10px"}} 
                                variant="contained" 
                                style={{marginTop: 5}}
                                disabled={!companyAdded}
                                    
                                onClick={() => {
                                    
                                    }}
                                >
                                            Promjena postojeće
                            </Button>
                             <Button sx={{height:"30px", fontSize:"10px"}} 
                                variant="contained" 
                                style={{marginTop: 5}}
                                className='button-yellow'
                                disabled={!companyAdded}
                                onClick={() => {
                                    
                                    }}
                                >
                                    
                                            Briši djelatnost
                            </Button>*/}
                             <Button sx={{height:"30px", fontSize:"10px"}} 
                            className='button-red'
                                variant="contained" 
                                style={{marginTop: 5}}
                                disabled={!companyAdded}
                                onClick={() => {
                                    
                                    setNaziv('');
                                    setNaziv2('');
                             
                                    setKomentar('');
                                    setKomentar2('');
                                    setKbr('');
                                    setSifra('');
                                    setSlova('');
                                    setUlica('');
                                    setMjesto('');

                                    setMjestoID(0);
                                    setUlicaID(0);
            
                
                
                                    setTableDataModal([]);

                                    setFilteredTableData([]);

                                    setSearchNaziv('');

                                    setCompanyAdded(false);

                                    setAddNew(false);

                                    setCompanyTKC('');

                                    let sel = {pozivni:'', tkc:''}

                                    setSelectedNetwork(sel);
    
          
                                    sessionStorage.setItem("selectedNet", JSON.stringify(sel));



                                    }}
                                >

                                        Odustani od te firme
                            </Button>
                        </div>


                        {addNew && <div className='ZuteStranice-form-add-naziv-container'>
                            <div className='ZuteStranice-form-search-naziv'>
                                <div className='ZuteStranice-naziv-djel'>
                                    Naziv djelatnosti:
                                </div>
                                <div className='ZuteStranice-naviv-search-field'>
                                 <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label={searchNaziv=== "" ? "Naziv": ""}
                                        
                                      
                                        variant="outlined"

                                        value={searchNaziv}
                                        
                                        onChange={(event) => {
                                            setSearchNaziv(event.target.value);
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter'){
                                                console.log('Enter Pressed')
                                                console.log(searchNaziv);
                                                getDjelatnosti()
                                            }
                                        }}
                                    />

                                </div>
                                <div className='ZuteStranice-naviv-search-box-action'>
                                 <Button sx={{height:"30px", fontSize:"10px"}} 
                                        variant="contained" 
                                        style={{}}
                                        onClick={() => {
                                            getDjelatnosti()
                                            }}
                                        >
                                            Sve nove djelatnosti
                                    </Button>

                                </div>
                            </div>

                            <div className='ZuteStranice-form-naziv-search-results'>
                            {companyAdded && filteredTableData.rows && <DataGrid
                                        rows={filteredTableData.rows}
                                        columns={filteredTableData.columns}
                                        initialState={{
                                            pagination: {
                                            paginationModel: {
                                                pageSize: 15,
                                            },
                                            },
                                        }}
                                        pageSizeOptions={[15]}
                                        onRowClick={(data)=> {
                                            const dataRow = allDjelatnosti.list.find(item=>item.naziv==data.row.naziv)
                                            Swal.fire({
                                                customClass: {
                                                    container: 'my-swal'
                                                  },
                                                title: "Jeste li sigurni da želite dodati novu djelatnost tvrtci?",
                                                showDenyButton: true,
                                                showCancelButton: true,
                                                confirmButtonText: "Spremi",
                                                denyButtonText: `Odustani`
                                              }).then((result) => {
                                                if (result.isConfirmed) {
                                                    console.log("Going to add!");
                                                    console.log(dataRow);
                                                    addDjelatnost(dataRow);

                                                    setAddNew(false);
                                                  
                                                } else if (result.isDenied) {

                                                    
                                                 
                                                }
                                              });
                                            console.log(data.row)
                                        }}

                                    
                                    />
                                    }
                            </div>
                        </div>}




                    </div>
                    {/*<div className="ZuteStranice-form-third-part">

                    <TableContainer  sx={{ maxHeight: 350 }} component={Paper}>
                            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                       
                                        <TableCell sx={{fontWeight:600}}>Red.br.</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Šifra</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Naziv tvrtke</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Mjesto</TableCell>
                                        <TableCell sx={{fontWeight:600}} align="right">Mreža</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                {tableDataModal.map((row) => (
                                    <TableRow
                                    key={row.rbr}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {row.rbr}
                                        </TableCell>
                                        <TableCell align="right">{row.ime_posiljke}</TableCell>
                                        <TableCell align="right">{row.poslano_iz_donata}</TableCell>
                                        <TableCell align="right">{row.stanje}</TableCell>
                                        <TableCell align="right">{row.stavaka}</TableCell>

                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>     */}           
                </div>
            </div>

        <div className='ZuteStranice-bottom' style={{display: modalIsOpen? 'flex':'none'}}
        
            onMouseDown={(e)=>onMouseDown(e)}>

        </div>

        </div>
    </Box >
  );
}

export default ZuteStranice;
